import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { BoatDetails } from '../boatList/BoatDetails';
import { AppDispatch } from '../../app/store';
import { useDispatch } from 'react-redux';
import { update } from '../boatList/boatListSlice';
import { analyticsService } from '../../services/AnalyticsService';


export interface BoatDetailsEditProps {
  show: boolean,
  handleClose: () => void,
  boat: BoatDetails
}

export function BoatDetailsEdit(props: BoatDetailsEditProps) {
  //   console.log(`BoatDetailsEdit show:${props.show} ${props.boat.id}`);
  const dispatch: AppDispatch = useDispatch();

  const [boatDetails, setBoatDetails] = React.useState<BoatDetails>(props.boat);

  // Track when boat edit modal is opened
  React.useEffect(() => {
    if (props.show) {
      analyticsService.logEvent('boat_management', {
        action_type: 'edit_opened',
        boat_id: props.boat.id,
        feature_name: 'boat_details_edit',
      });
    }
  }, [props.show, props.boat.id]);

  function handleClose() {
    console.log(`BoatDetailsEdit.handleClose ${props.boat.id}`);

    // Track boat edit cancellation
    analyticsService.logEvent('boat_management', {
      action_type: 'edit_cancelled',
      boat_id: props.boat.id,
      feature_name: 'boat_details_edit',
    });

    props.handleClose();
    // TODO should this reset state?
  }

  function handleSave() {
    console.log(`BoatDetailsEdit.handleSave ${props.boat.id}`);

    // Track boat edit save
    analyticsService.logEvent('boat_management', {
      action_type: 'boat_updated',
      boat_id: props.boat.id,
      feature_name: 'boat_details_edit',
      has_name_change: boatDetails.name !== props.boat.name,
      has_handicap_change: boatDetails.handicap !== props.boat.handicap,
    });

    dispatch(update(boatDetails));
    props.handleClose();
    // TODO should this reset state?
  }

  function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    console.log('BoatDetailsEdit.handleInputChange', event);
    const name = event.target.name;
    const value = event.target.type == 'number' ? event.target.valueAsNumber : event.target.value;
    console.log(`BoatDetailsEdit.handleInputChange name:${name} value:${value}`);
    setBoatDetails((values) => ({ ...values, [name]: value }));
  }

  return <Modal show={props.show} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>Edit Boat Details</Modal.Title>
    </Modal.Header>

    <Modal.Body>
      <Form>
        <Form.Group className="mb-3" controlId="id">
          <Form.Label>Id</Form.Label>
          <Form.Control readOnly disabled type="text" name="id" value={boatDetails.id} onChange={handleInputChange} />
        </Form.Group>
        <Form.Group className="mb-3" controlId="name">
          <Form.Label>Name</Form.Label>
          <Form.Control type="text" name="name" value={boatDetails.name} onChange={handleInputChange} />
        </Form.Group>
        <Form.Group className="mb-3" controlId="handicap">
          <Form.Label>Handicap</Form.Label>
          <Form.Control type="number" name="handicap" value={boatDetails.handicap} onChange={handleInputChange} />
        </Form.Group>
      </Form>
    </Modal.Body>

    <Modal.Footer>
      <Button variant="secondary" onClick={handleClose}>Close</Button>
      <Button variant="primary" onClick={handleSave}>Save changes</Button>
    </Modal.Footer>
  </Modal>;
}
